import React, { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { BRAND } from "../data/content";

const FloatingCTA = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setVisible(window.scrollY > 600);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <a
            data-testid="floating-connect-cta"
            href={BRAND.parentUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={`fixed left-1/2 -translate-x-1/2 z-50 inline-flex items-center gap-2 px-6 py-3.5 bg-marker-red text-white font-sans font-bold text-base rounded-full shadow-[0px_10px_28px_rgba(224,82,54,0.45)] hover:scale-[1.04] transition-all duration-300 ${
                visible
                    ? "bottom-6 sm:bottom-8 opacity-100"
                    : "-bottom-24 opacity-0 pointer-events-none"
            }`}
            style={{ paddingRight: "1.25rem" }}
        >
            <span className="font-handwriting text-2xl leading-none mr-1">
                ✓
            </span>
            <span>{BRAND.cta}</span>
            <ArrowUpRight size={18} strokeWidth={2.5} />
        </a>
    );
};

export default FloatingCTA;
